module.exports = __webpack_public_path__ + "static/how-it-works-3-7cf39f9f09037ce3d31ed3711f1a1093.svg";